import { accessGuard } from './shared/guards/access.guard';
import { environment } from '../environments/environment';
import { LandingComponent } from './landing/components/landing.component';
import { LoginComponent } from './shared/components/login/login.component';
import { RegisterComponent } from './shared/components/register/register.component';
import { ResetPasswordComponent } from './shared/components/reset-password/reset-password.component';
import { Routes } from '@angular/router';

export const routes: Routes = [{
  path: '',
  component: LandingComponent
}, {
  path: 'login',
  component: LoginComponent,
  data: { title: environment.title }
}, {
  path: 'register',
  component: RegisterComponent,
  data: { title: environment.title }
}, {
  path: 'resetpassword',
  component: ResetPasswordComponent
}, {
  path: 'home',
  loadComponent: () => import('./home/components/home.component').then(m => m.HomeComponent),
  canActivate: [accessGuard],
  children: [{
    path: 'users',
    loadComponent: () => import('./users/components/users.component').then(m => m.UsersComponent),
  }, {
    path: '',
    loadComponent: () => import('./story/components/story.component').then(m => m.StoryComponent),
  }],
}, {
  path: '**',
  redirectTo: '',
  pathMatch: 'full'
}];